import { api } from '../../shared/api/client';

// Customer accepts their own quote directly — same endpoint admin uses after confirming by
// phone (rteh's Accept Quote button), gated by role/ownership server-side.
export async function acceptQuote(requestId: string) {
  return api.patch(`/api/v1/quotes/request/${requestId}/accept`);
}

// Single counter-offer haggle flow: customer proposes one new total below the quoted price.
export async function submitCounterOffer(requestId: string, payload: { amount: number; note?: string }) {
  return api.post(`/api/v1/quotes/request/${requestId}/counter`, payload);
}
